import dayjs from "dayjs";
import { DateFilterValue } from "./interfaces";

class SearchQuery {
  private conditions: string[] = [];

  addCondition(condition: string) {
    if (condition) {
      this.conditions.push(condition);
    }
    return this;
  }

  addSearchParameter(field: string, comparator: string, value: string) {
    return this.addCondition(`${field} ${comparator} ${value}`);
  }

  addSearchParameters(field: string, comparator: string, values: string[]) {
    if (!values.length) return this;
    const orConditions = values.map(
      (value) => `${field} ${comparator} ${value}`,
    );
    const grouped =
      orConditions.length > 1
        ? `(${orConditions.join(" || ")})`
        : orConditions[0];
    return this.addCondition(grouped);
  }

  addDateRangeParameter(field: string, value: DateFilterValue) {
    if (value.relativeValue) {
      const now = dayjs();

      switch (value.relativeValue) {
        case "today": {
          const start = now.startOf("day").toISOString();
          const end = now.endOf("day").toISOString();
          return this.addCondition(
            `${field} >= ${start} && ${field} <= ${end}`,
          );
        }

        case "7days": {
          const start = now.subtract(7, "day").startOf("day").toISOString();
          const end = now.endOf("day").toISOString();
          return this.addCondition(
            `${field} >= ${start} && ${field} <= ${end}`,
          );
        }

        case "30days": {
          const start = now.subtract(30, "day").startOf("day").toISOString();
          const end = now.endOf("day").toISOString();
          return this.addCondition(
            `${field} >= ${start} && ${field} <= ${end}`,
          );
        }
      }
    }

    if (value.range?.from && value.range?.to) {
      const from = dayjs(value.range.from).startOf("day").toISOString();
      const to = dayjs(value.range.to).endOf("day").toISOString();
      return this.addCondition(`${field} >= ${from} && ${field} <= ${to}`);
    }

    return this;
  }

  addLookup(fields: string[], value: string) {
    const orConditions = fields.map((field) => `${field} ~= ${value}`);
    const grouped =
      orConditions.length > 1
        ? `(${orConditions.join(" || ")})`
        : orConditions[0];
    return this.addCondition(grouped);
  }

  toString() {
    return this.conditions.join(" && ");
  }
}

export default SearchQuery;
